import React, { useState } from "react";
import Typical from "react-typical";
import axios from "axios";
import { toast } from "react-toastify";
import imgBack from "../../../src/images/mailz.jpeg";
import load1 from "../../../src/images/load2.gif";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import Footer from "../../PortfolioContainer/Footer/Footer";
import "./ContactMe.css";

export default function ContactMe(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };

  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const handlePlaceReview=event=>{
    event.preventDefault();
    const form=event.target;
    const name=`${form.firstName.value} `;
    const address=` ${form.address.value}`;
    const email=form.email.value;
    const message=form.message.value;

   const review={
     name,
     address,
     email,
     message
   }

   fetch('https://merajul-hasan-portfolio-server.vercel.app/UserInfo', {
      method:'POST',
      headers: {
         'content-type': 'application/json'
      },
      body: JSON.stringify(review)
   })
    .then(res=>res.json())
    .then(data=> {
        console.log(data)
        if(data.acknowledged){
         alert('Your Contact Placed Successfully. Thank You')
         form.reset();
       } 
    })
    .catch(err => console.error(err));
   
  }

  return (
    <div className="main-container fade-in" id={props.id || ""}>
      <ScreenHeading subHeading={"Lets Keep In Touch"} title={"Contact Me"} />
      <div className="central-form">
        
        <div className="col">
          <h2 className="title">
            <Typical loop={Infinity} steps={["Get In Touch 📧", 1000]} />
          </h2>{" "}
          <div className="perso_contact">
            <p><span className="perso_email_whapp">Email :</span> hmmerajulhasan@gmail.com</p>
            <p><span className="perso_email_whapp">Whatsapp :</span> +880 1704357909</p>
          </div>
          <a href="https://www.facebook.com/merajoulehasan.utsho" target="_blank" data-bs-toggle="tooltip" data-bs-placement="bottom" title="facebook">
            <i className="fa fa-facebook-square" />
          </a>
          <a href="https://www.linkedin.com/in/h-m-merajul-hasan-62687b23a/" target="_blank" data-bs-toggle="tooltip" data-bs-placement="bottom" title="linkedin">
             <i className="fa fa-linkedin" />
          </a>
          <a href="https://www.instagram.com/h_m_merajoule_hasasn/" target="_blank" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Instagram">
            <i className="fa fa-instagram" />
          </a>
          <a href="https://github.com/HNMerajulhasan" target="_blank" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Github">
                <i className="fa fa-github" />
              </a>
         
        </div>
        <div className="back-form">
          <div className="img-back">
            <h4>Send Your Email Here!</h4>
            <img src={imgBack} alt="image not found" />
          </div>
  
          <form onSubmit={handlePlaceReview}>
            <div className='grid grid-cols-1 lg:grid-cols-2 gap-4'>
              <input name="firstName" type="text" placeholder="Your Name" className="input input-ghost w-full input-bordered" required />
              <input name="address" type="text" placeholder="Your Address" className="input input-ghost w-full input-bordered" required />
              <input name="email" type="text" placeholder="Your email" className="input input-ghost w-full input-bordered" required />
            </div>
            <textarea name="message" className="textarea textarea-bordered h-24 w-full mt-3" placeholder="Your Message..." required></textarea>

            <div className="send-btn">
              <button type="submit">
                Send . . . 
                <i className="fa fa-paper-plane ml-2 mr-2" />
                
                {/* {(
                  <b className="load">
                    <img src={load1} alt="image not responding" />
                  </b>
                )  (
                  ""
                )} */}
              </button>
            </div>

          </form>

        </div>
      </div>
      <Footer />
    </div>
  );
}
